import React from 'react';
import PaymentFormClaroSocioContainer from '../containers/PaymentFormClaroSocioContainer'
import { Page } from 'react-onsenui';
import * as sdkclaro from '@claro/sdkclaromicrofront'
import PlansContainer from "../containers/PlansContainer"
import { GenericFormContextProvider } from '../../context/genericFormContext';

const MenuTelcelPage = ({ match, location, history  }) => {
    const { 
        state: { 
            sdkVersion, 
            paymentsConfig, 
            isClaroPartner,
            serviceConfigIndex,
            tagServiceId,
            paramsNewOfferTelcel,
            isContainerTelcel,
            paymentMethods
        }
    } = location;
    sdkclaro.getInstance().switchGoBackButton(true)
    return (
        <Page id="menu-plans-page">
            {
                (serviceConfigIndex == 0 || serviceConfigIndex == 1 || serviceConfigIndex == 5)?
                <GenericFormContextProvider>
                    <PaymentFormClaroSocioContainer 
                        serviceConfigIndex={serviceConfigIndex} 
                        sdkVersion = {sdkVersion}
                        paymentsConfig = {paymentsConfig} 
                        isClaroPartner = {isClaroPartner}
                        tagServiceId={tagServiceId}
                        paramsNewOfferTelcel= {paramsNewOfferTelcel}
                        isContainerTelcel={isContainerTelcel}
                        history = {history}
                    />
                </GenericFormContextProvider>
                :
                <PlansContainer
                    serviceConfigIndex={serviceConfigIndex} 
                    sdkVersion = {sdkVersion} 
                    paymentsConfig = {paymentsConfig} 
                    isClaroPartner = {isClaroPartner}
                    tagServiceId={tagServiceId}
                    paramsNewOfferTelcel= {paramsNewOfferTelcel}
                    history = {history}
                    isContainerTelcel={isContainerTelcel}
                    paymentMethods={paymentMethods}
                />
            }
        </Page>    
  );
};


export default MenuTelcelPage